import { makeStyles } from '@material-ui/core'

const styles = makeStyles((theme) => ({
  colorPickers: {
    backgroundColor: theme.palette.background.paper,
    borderRadius: theme.spacing(1),
    padding: theme.spacing(1),
    margin: theme.spacing(1, 0),
  },
}))

export default styles
